var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-12" }, [
    _c(
      "form",
      {
        attrs: { id: "submission-agent-form", novalidate: "" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            $event.stopPropagation()
          },
        },
      },
      [
        _c(
          "div",
          { staticClass: "row align-items-end" },
          [
            _c(
              "field",
              {
                attrs: {
                  "size-class": "col-md-4 col-12",
                  title: _vm.$t("account.fullName"),
                  "container-class": "w-100",
                },
              },
              [
                _c("material-input", {
                  attrs: {
                    "validator-context": _vm.$v,
                    "no-label": "",
                    name: "submission-agent[first-name]",
                    placeholder: _vm.$t("account.givenName"),
                    label: _vm.$t("account.givenName"),
                    "hidden-label": "",
                  },
                  model: {
                    value: _vm.editingAgent.givenName,
                    callback: function ($$v) {
                      _vm.$set(_vm.editingAgent, "givenName", $$v)
                    },
                    expression: "editingAgent.givenName",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "field",
              {
                attrs: {
                  "size-class": "col-md-4 col-12",
                  "container-class": "w-100",
                },
              },
              [
                _c("material-input", {
                  attrs: {
                    "validator-context": _vm.$v,
                    "no-label": "",
                    name: "submission-agent[middle-name]",
                    placeholder: _vm.$t("account.middleName"),
                    label: _vm.$t("account.middleName"),
                    "hidden-label": "",
                  },
                  model: {
                    value: _vm.editingAgent.middleName,
                    callback: function ($$v) {
                      _vm.$set(_vm.editingAgent, "middleName", $$v)
                    },
                    expression: "editingAgent.middleName",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "field",
              {
                attrs: {
                  "size-class": "col-md-4 col-12",
                  "container-class": "w-100",
                },
              },
              [
                _c("material-input", {
                  attrs: {
                    "validator-context": _vm.$v,
                    "no-label": "",
                    name: "submission-agent[last-name]",
                    placeholder: _vm.$t("account.familyName"),
                    label: _vm.$t("account.familyName"),
                    "hidden-label": "",
                  },
                  model: {
                    value: _vm.editingAgent.familyName,
                    callback: function ($$v) {
                      _vm.$set(_vm.editingAgent, "familyName", $$v)
                    },
                    expression: "editingAgent.familyName",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row align-items-end" },
          [
            _c(
              "field",
              {
                attrs: {
                  "size-class": "col-md-4 col-12",
                  title: _vm.$t("account.email"),
                  "container-class": "w-100",
                },
              },
              [
                _c("material-input", {
                  attrs: {
                    "validator-context": _vm.$v,
                    "no-label": "",
                    name: "submission-agent[email]",
                    placeholder: _vm.$t("account.email"),
                    label: _vm.$t("account.email"),
                    "hidden-label": "",
                  },
                  model: {
                    value: _vm.editingAgent.email,
                    callback: function ($$v) {
                      _vm.$set(_vm.editingAgent, "email", $$v)
                    },
                    expression: "editingAgent.email",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "field",
              {
                attrs: {
                  "size-class": "col-md-4 col-12",
                  title: _vm.$t("account.phoneNumber"),
                  "container-class": "w-100",
                },
              },
              [
                _c("material-input", {
                  attrs: {
                    "validator-context": _vm.$v,
                    "no-label": "",
                    name: "submission-agent[phone-number]",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var inputClasses = ref.inputClasses
                        return [
                          _c("phone-input", {
                            class:
                              "material-input form-control " + inputClasses,
                            attrs: {
                              id: "phoneNumber",
                              name: "phoneNoFill",
                              placeholder: _vm.$t("account.phoneNumber"),
                              type: "text",
                              "data-lpignore": "true",
                              "emit-value": "",
                              value: _vm.editingAgent.phoneNumber,
                            },
                            on: {
                              change: function ($event) {
                                _vm.editingAgent.phoneNumber = $event
                              },
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                  model: {
                    value: _vm.editingAgent.phoneNumber,
                    callback: function ($$v) {
                      _vm.$set(_vm.editingAgent, "phoneNumber", $$v)
                    },
                    expression: "editingAgent.phoneNumber",
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "d-none", attrs: { for: "phoneNumber" } },
                  [_vm._v(_vm._s(_vm.$t("account.phoneNumber")))]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "field",
              {
                attrs: {
                  "size-class": "col-md-4 col-12",
                  title: _vm.$t("account.altPhoneNumber"),
                  "container-class": "w-100",
                },
              },
              [
                _c("material-input", {
                  attrs: {
                    "validator-context": _vm.$v,
                    "no-label": "",
                    name: "submission-agent[alt-phone-number]",
                    "class-name": "fe-phone",
                    placeholder: _vm.$t("account.altPhoneNumber"),
                    label: _vm.$t("account.altPhoneNumber"),
                    "hidden-label": "",
                  },
                  model: {
                    value: _vm.editingAgent.altPhoneNumber,
                    callback: function ($$v) {
                      _vm.$set(_vm.editingAgent, "altPhoneNumber", $$v)
                    },
                    expression: "editingAgent.altPhoneNumber",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row align-items-end" },
          [
            _c(
              "field",
              {
                attrs: {
                  "size-class": "col-md-4 col-12",
                  title: _vm.$t(
                    "settings.accountTab.licenseRegistrationNumber"
                  ),
                  "container-class": "w-100",
                },
              },
              [
                _c("material-input", {
                  attrs: {
                    "validator-context": _vm.$v,
                    "no-label": "",
                    name: "submission-agent[license-registration-number]",
                    placeholder: _vm.$t(
                      "settings.accountTab.licenseRegistrationNumber"
                    ),
                    label: _vm.$t(
                      "settings.accountTab.licenseRegistrationNumber"
                    ),
                    "hidden-label": "",
                  },
                  model: {
                    value: _vm.editingAgent.licenseRegistrationNumber,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.editingAgent,
                        "licenseRegistrationNumber",
                        $$v
                      )
                    },
                    expression: "editingAgent.licenseRegistrationNumber",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "field",
              {
                attrs: {
                  "size-class": "col-md-4 col-12",
                  title: _vm.$t("settings.accountTab.firmCode"),
                  "container-class": "w-100",
                },
              },
              [
                _c("material-input", {
                  attrs: {
                    "validator-context": _vm.$v,
                    "no-label": "",
                    name: "submission-agent[firm-code]",
                    placeholder: _vm.$t("settings.accountTab.firmCode"),
                    label: _vm.$t("settings.accountTab.firmCode"),
                    "hidden-label": "",
                  },
                  model: {
                    value: _vm.editingAgent.firmCode,
                    callback: function ($$v) {
                      _vm.$set(_vm.editingAgent, "firmCode", $$v)
                    },
                    expression: "editingAgent.firmCode",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "field",
              {
                attrs: {
                  "size-class": "col-md-4 col-12",
                  title: _vm.$t("settings.accountTab.expertProfileNumber"),
                  "container-class": "w-100",
                  icon: "fa-info-circle",
                  "icon-tooltip": _vm.$t(
                    "direct-to-lender.participants.youCanFindThisInExpert"
                  ),
                },
              },
              [
                _c("material-input", {
                  attrs: {
                    "validator-context": _vm.$v,
                    "no-label": "",
                    name: "submission-agent[expert-profile-number]",
                    "class-name": "fe-num-field",
                    placeholder: _vm.$t(
                      "settings.accountTab.expertProfileNumber"
                    ),
                    label: _vm.$t("settings.accountTab.expertProfileNumber"),
                    "hidden-label": "",
                  },
                  model: {
                    value: _vm.editingAgent.expertProfileNumber,
                    callback: function ($$v) {
                      _vm.$set(_vm.editingAgent, "expertProfileNumber", $$v)
                    },
                    expression: "editingAgent.expertProfileNumber",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row align-items-end mb-4" },
          [
            _c(
              "field",
              {
                attrs: {
                  "size-class": "col-12",
                  title: _vm.$tc("global.words.address", 1),
                  "container-class": "w-100",
                },
              },
              [
                _c("address-section", {
                  attrs: {
                    address: _vm.editingAgent.address,
                    "custom-expressions": _vm.addressCustomExpressions,
                    "validator-context": _vm.$v,
                  },
                  on: {
                    change: function ($event) {
                      _vm.editingAgent.address = $event
                    },
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "row justify-content-end" }, [
          _c("div", { staticClass: "col-auto" }, [
            _c(
              "button",
              {
                ref: "submitButton",
                staticClass: "btn btn-primary submission-agent submit-changes",
                attrs: { disabled: _vm.$v.$invalid },
                on: { click: _vm.handleSubmit },
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("global.words.save")) +
                    "\n        "
                ),
              ]
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }